var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.getters['app/legacyUrl'].length && _vm.$store.getters['app/beta'])?_c('div',{staticClass:"beta-toggle-component-container"},[_c('icon',{attrs:{"name":"beta","variant":"white"}}),_vm._v("\n  Beta "),_c('a',{staticClass:"back",attrs:{"href":_vm.legacyUrl}},[_vm._v("Back to Original")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }